import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";

import { Container, Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import axios from "axios";
import { endpoint } from "../../utils/api";

const Login = ({ setToken }) => {
  const [loginfail, setLoginFail] = useState(null);
  const [validated, setValidated] = useState(false);

  /*
    if (isAuthenticated) {
        return <Redirect to="/templates"/>
     }
     */

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Attempted to Send");
    const formData = new FormData(e.target),
      formDataObj = Object.fromEntries(formData.entries());

    await axios
      .post(`${endpoint}/auth`, formDataObj)
      .then(function (response) {
        if (response.status === 200) {
          console.log("Message Sent.");
          setToken(response.data.token);
        } else {
          console.log(response);
          console.log(response);

          setLoginFail(response.statusText);
          setValidated(true);
        }
      })
      .catch((error) => {
        console.log(error.response.data);
        setLoginFail(error.response.data)
        setValidated(true);
      });
  };

  return (
    <div className="login-container">
      <Container className="login">
        <Row>
          <Col>
            <div style={{ textAlign: "center" }}>
              <div className="loginLogo" style={{ display: "block" }} />
            </div>
            <Form onSubmit={handleSubmit} title="Login" description="Please enter your name and email address to login">
              <Form.Group as={Col} controlId="formGridContactEmail">
                <Form.Label className="login-label">Email</Form.Label>
                <InputGroup className="mb-2">
                  <Form.Control placeholder="Email..." name="email" />
                  <Form.Control.Feedback type="invalid">Please enter a valid email.</Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group as={Col} controlId="formGridContactEmail">
                <Form.Label className="login-label">Password</Form.Label>
                <InputGroup className="mb-2">
                  <Form.Control type="password" placeholder="Password..." name="password" />
                  <Form.Control.Feedback type="invalid">Please enter a valid password.</Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              {loginfail !== null && <span style={{ color: "red" }}>{loginfail}</span>}

              <div className="form-group" style={{ textAlign: "center" }}>
                <button className="btn primary-button border-button btn-lg" type="submit">
                  Login
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
